import { useEffect, useRef, useState } from 'react';
import { searchSite } from '../../lib/siteSearch';

// Debounced site search with keyboard navigation over the flat result order.
export const useSiteSearch = (initial = '') => {
  const [q, setQ] = useState(initial);
  const [r, setR] = useState(null);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(-1);
  const ctrl = useRef(null);

  useEffect(() => {
    if (q.trim().length < 2) { setR(null); setLoading(false); return undefined; }
    setLoading(true);
    const t = setTimeout(() => {
      ctrl.current?.abort();
      ctrl.current = new AbortController();
      searchSite(q, ctrl.current.signal).then((res) => { setR(res); setActive(-1); }).catch(() => {}).finally(() => setLoading(false));
    }, 180);
    return () => clearTimeout(t);
  }, [q]);

  return { q, setQ, r, loading, active, setActive };
};

// Arrow keys move through results; Enter opens the first link of the active row.
export const keyNav = (s, total, container) => (e) => {
  if (!total) return false;
  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
    e.preventDefault();
    const n = e.key === 'ArrowDown' ? (s.active + 1) % total : (s.active - 1 + total) % total;
    s.setActive(n);
    container.current?.querySelector(`[data-search-idx="${n}"]`)?.scrollIntoView({ block: 'nearest' });
    return true;
  }
  if (e.key === 'Enter' && s.active >= 0) {
    e.preventDefault();
    container.current?.querySelector(`[data-search-idx="${s.active}"] a, a[data-search-idx="${s.active}"]`)?.click();
    return true;
  }
  return false;
};
